import React from "react";
import { Link } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";

const LABELS = {
  payouts: {
    title: "Payouts",
    body: "The carrier payout register — who is owed what, mark payouts as paid with the UPI transaction reference, and view per-carrier payout history.",
  },
  disputes: {
    title: "Disputes & claims",
    body: "Open disputes with the parties, admin notes, resolution history, and quick actions to issue a refund or release a held payment.",
  },
  pricing: {
    title: "Pricing configuration",
    body: "Edit handover fees, per-km rates by vehicle, tier caps, protection fee, commission and the minimum earnings floor — with a full change history.",
  },
};

const Placeholder = ({ page }) => {
  const info = LABELS[page] || { title: "Coming soon", body: "This screen is on the roadmap." };
  return (
    <div className="p-8">
      <Link to="/admin" className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900 mb-4">
        <ArrowLeft className="w-3 h-3"/> Back to dashboard
      </Link>
      <div className="max-w-lg rounded-2xl border border-slate-200 bg-white p-8 text-center" data-testid={`placeholder-${page}`}>
        <div className="w-12 h-12 mx-auto rounded-xl bg-amber-100 text-amber-700 grid place-items-center">
          <Construction className="w-6 h-6"/>
        </div>
        <h1 className="mt-4 font-display text-xl font-bold text-slate-900">{info.title}</h1>
        <p className="text-sm text-slate-600 mt-2">{info.body}</p>
        <p className="text-[11px] text-slate-400 mt-4">Ships in <b>Phase C</b> of the admin panel roadmap.</p>
      </div>
    </div>
  );
};

export default Placeholder;
